<div class="page-title-area page-title-four" style="margin-bottom: 60px;">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="page-title-item">
                <h2>{{'MENU.DOCTORSLOTS' | translate}}</h2>
                <ul>
                    <li><a routerLink="/">{{'MENU.HOME' | translate}}</a></li>
                    <li><i class="icofont-simple-right"></i></li>
                    <li>{{'MENU.DOCTORSLOTS' | translate}}</li>
                </ul>
            </div>
        </div>
    </div>
</div>
<app-add-appointment></app-add-appointment>